import { EntityStatusBadgeVariant } from '@frontend/common';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export enum EquipmentStateName {
    EQUIPMENT_ANY_STATE = 'equipment_any_state',
    EQUIPMENT_CREATED = 'equipment_created',
    EQUIPMENT_AVAILABLE = 'equipment_available',
    EQUIPMENT_IN_USE = 'equipment_in_use',
    EQUIPMENT_MAINTENANCE_REQUIRED = 'equipment_maintenance_required',
    EQUIPMENT_INCOMPLETE = 'equipment_incomplete',
    EQUIPMENT_IN_MAINTENANCE = 'equipment_in_maintenance',
    EQUIPMENT_MAINTENANCE = 'equipment_maintenance',
    EQUIPMENT_MAINTAINED = 'equipment_maintained',
    EQUIPMENT_CHARGING = 'equipment_charging',
    EQUIPMENT_REVIEW_REQUIRED = 'equipment_review_required',
    EQUIPMENT_IN_REVIEW = 'equipment_in_review',
    EQUIPMENT_REVIEWED = 'equipment_reviewed',
    EQUIPMENT_UNAVAILABLE = 'equipment_unavailable',
    EQUIPMENT_CERTIFICATION = 'equipment_certification',
    EQUIPMENT_LOST = 'equipment_lost',
    EQUIPMENT_BROKEN = 'equipment_broken',
    EQUIPMENT_CONTAMINATED = 'equipment_contaminated',
    EQUIPMENT_FOUND = 'equipment_found',
    EQUIPMENT_IN_TRANSIT = 'equipment_in_transit',
    EQUIPMENT_WAITING_FOR_RETURN = 'equipment_waiting_for_return',
    UNKNOWN = ''
}

export class EquipmentState {
    static readonly EQUIPMENT_ANY_STATE = new EquipmentState(
        EquipmentStateName.EQUIPMENT_ANY_STATE,
        (
            <FormattedMessage
                id='EquipmentState.equipment_any_state'
                description='The displayed value for the EquipmentState equipment_any_state'
                defaultMessage='Any state'
            />
        )
    );
    static readonly EQUIPMENT_CREATED = new EquipmentState(
        EquipmentStateName.EQUIPMENT_CREATED,
        (
            <FormattedMessage
                id='EquipmentState.equipment_created'
                description='The displayed value for the EquipmentState equipment_created'
                defaultMessage='Equipment created'
            />
        )
    );

    static readonly EQUIPMENT_AVAILABLE = new EquipmentState(
        EquipmentStateName.EQUIPMENT_AVAILABLE,
        (
            <FormattedMessage
                id='EquipmentState.equipment_available'
                description='The displayed value for the EquipmentState equipment_available'
                defaultMessage='Equipment available'
            />
        )
    );

    static readonly EQUIPMENT_IN_USE = new EquipmentState(
        EquipmentStateName.EQUIPMENT_IN_USE,
        (
            <FormattedMessage
                id='EquipmentState.equipment_in_use'
                description='The displayed value for the EquipmentState equipment_in_use'
                defaultMessage='Equipment in use'
            />
        )
    );
    static readonly EQUIPMENT_MAINTENANCE_REQUIRED = new EquipmentState(
        EquipmentStateName.EQUIPMENT_MAINTENANCE_REQUIRED,
        (
            <FormattedMessage
                id='EquipmentState.equipment_maintenance_required'
                description='The displayed value for the EquipmentState equipment_maintenance_required'
                defaultMessage='Equipment maintenance required'
            />
        )
    );
    static readonly EQUIPMENT_INCOMPLETE = new EquipmentState(
        EquipmentStateName.EQUIPMENT_INCOMPLETE,
        (
            <FormattedMessage
                id='EquipmentState.equipment_incomplete'
                description='The displayed value for the EquipmentState equipment_incomplete'
                defaultMessage='Equipment incomplete'
            />
        )
    );
    static readonly EQUIPMENT_IN_MAINTENANCE = new EquipmentState(
        EquipmentStateName.EQUIPMENT_IN_MAINTENANCE,
        (
            <FormattedMessage
                id='EquipmentState.equipment_in_maintenance'
                description='The displayed value for the EquipmentState equipment_in_maintenance'
                defaultMessage='Equipment in maintenance'
            />
        )
    );
    static readonly EQUIPMENT_MAINTENANCE = new EquipmentState(
        EquipmentStateName.EQUIPMENT_MAINTENANCE,
        (
            <FormattedMessage
                id='EquipmentState.equipment_maintenance'
                description='The displayed value for the EquipmentState equipment_maintenance'
                defaultMessage='Equipment maintenance'
            />
        )
    );
    static readonly EQUIPMENT_MAINTAINED = new EquipmentState(
        EquipmentStateName.EQUIPMENT_MAINTAINED,
        (
            <FormattedMessage
                id='EquipmentState.equipment_maintained'
                description='The displayed value for the EquipmentState equipment_maintained'
                defaultMessage='Equipment maintained'
            />
        )
    );

    static readonly EQUIPMENT_CHARGING = new EquipmentState(
        EquipmentStateName.EQUIPMENT_CHARGING,
        (
            <FormattedMessage
                id='EquipmentState.equipment_charging'
                description='The displayed value for the EquipmentState equipment_charging'
                defaultMessage='Equipment charging'
            />
        )
    );

    static readonly EQUIPMENT_REVIEW_REQUIRED = new EquipmentState(
        EquipmentStateName.EQUIPMENT_REVIEW_REQUIRED,
        (
            <FormattedMessage
                id='EquipmentState.equipment_review_required'
                description='The displayed value for the EquipmentState equipment_review_required'
                defaultMessage='Equipment review required'
            />
        )
    );

    static readonly EQUIPMENT_IN_REVIEW = new EquipmentState(
        EquipmentStateName.EQUIPMENT_IN_REVIEW,
        (
            <FormattedMessage
                id='EquipmentState.equipment_in_review'
                description='The displayed value for the EquipmentState equipment_in_review'
                defaultMessage='Equipment in review'
            />
        )
    );

    static readonly EQUIPMENT_REVIEWED = new EquipmentState(
        EquipmentStateName.EQUIPMENT_REVIEWED,
        (
            <FormattedMessage
                id='EquipmentState.equipment_reviewed'
                description='The displayed value for the EquipmentState equipment_reviewed'
                defaultMessage='Equipment reviewed'
            />
        )
    );

    static readonly EQUIPMENT_UNAVAILABLE = new EquipmentState(
        EquipmentStateName.EQUIPMENT_UNAVAILABLE,
        (
            <FormattedMessage
                id='EquipmentState.equipment_unavailable'
                description='The displayed value for the EquipmentState equipment_unavailable'
                defaultMessage='Equipment unavailable'
            />
        )
    );

    static readonly EQUIPMENT_CERTIFICATION = new EquipmentState(
        EquipmentStateName.EQUIPMENT_CERTIFICATION,
        (
            <FormattedMessage
                id='EquipmentState.equipment_certification'
                description='The displayed value for the EquipmentState equipment_certification'
                defaultMessage='Equipment certification'
            />
        )
    );

    static readonly EQUIPMENT_LOST = new EquipmentState(
        EquipmentStateName.EQUIPMENT_LOST,
        (
            <FormattedMessage
                id='EquipmentState.equipment_lost'
                description='The displayed value for the EquipmentState equipment_lost'
                defaultMessage='Equipment lost'
            />
        )
    );

    static readonly EQUIPMENT_BROKEN = new EquipmentState(
        EquipmentStateName.EQUIPMENT_BROKEN,
        (
            <FormattedMessage
                id='EquipmentState.equipment_broken'
                description='The displayed value for the EquipmentState equipment_broken'
                defaultMessage='Equipment broken'
            />
        )
    );

    static readonly EQUIPMENT_CONTAMINATED = new EquipmentState(
        EquipmentStateName.EQUIPMENT_CONTAMINATED,
        (
            <FormattedMessage
                id='EquipmentState.equipment_contaminated'
                description='The displayed value for the EquipmentState equipment_contaminated'
                defaultMessage='Equipment contaminated'
            />
        )
    );
    static readonly EQUIPMENT_FOUND = new EquipmentState(
        EquipmentStateName.EQUIPMENT_FOUND,
        (
            <FormattedMessage
                id='EquipmentState.equipment_found'
                description='The displayed value for the EquipmentState equipment_found'
                defaultMessage='Equipment found'
            />
        )
    );
    static readonly EQUIPMENT_IN_TRANSIT = new EquipmentState(
        EquipmentStateName.EQUIPMENT_IN_TRANSIT,
        (
            <FormattedMessage
                id='EquipmentState.equipment_in_transit'
                description='The displayed value for the EquipmentState equipment_in_transit'
                defaultMessage='Equipment in transit'
            />
        )
    );
    static readonly EQUIPMENT_WAITING_FOR_RETURN = new EquipmentState(
        EquipmentStateName.EQUIPMENT_WAITING_FOR_RETURN,
        (
            <FormattedMessage
                id='EquipmentState.equipment_waiting_for_return'
                description='The displayed value for the EquipmentState equipment_waiting_for_return'
                defaultMessage='Equipment waiting for return'
            />
        )
    );
    static readonly UNKNOWN = new EquipmentState(
        EquipmentStateName.UNKNOWN,
        (
            <FormattedMessage
                id='EquipmentState.unknown'
                description='The displayed value for the EquipmentState unknown'
                defaultMessage='Unknown'
            />
        )
    );

    static readonly ALL = [
        EquipmentState.EQUIPMENT_ANY_STATE,
        EquipmentState.EQUIPMENT_CREATED,
        EquipmentState.EQUIPMENT_AVAILABLE,
        EquipmentState.EQUIPMENT_IN_USE,
        EquipmentState.EQUIPMENT_MAINTENANCE_REQUIRED,
        EquipmentState.EQUIPMENT_INCOMPLETE,
        EquipmentState.EQUIPMENT_IN_MAINTENANCE,
        EquipmentState.EQUIPMENT_MAINTENANCE,
        EquipmentState.EQUIPMENT_MAINTAINED,
        EquipmentState.EQUIPMENT_CHARGING,
        EquipmentState.EQUIPMENT_REVIEW_REQUIRED,
        EquipmentState.EQUIPMENT_IN_REVIEW,
        EquipmentState.EQUIPMENT_REVIEWED,
        EquipmentState.EQUIPMENT_UNAVAILABLE,
        EquipmentState.EQUIPMENT_CERTIFICATION,
        EquipmentState.EQUIPMENT_LOST,
        EquipmentState.EQUIPMENT_BROKEN,
        EquipmentState.EQUIPMENT_CONTAMINATED,
        EquipmentState.EQUIPMENT_FOUND,
        EquipmentState.EQUIPMENT_IN_TRANSIT,
        EquipmentState.EQUIPMENT_WAITING_FOR_RETURN
    ];

    private constructor(
        public readonly value: EquipmentStateName,
        public readonly displayName: React.ReactNode
    ) {}

    static getByValue(action: EquipmentStateName): EquipmentState | undefined {
        return this.ALL.find((a) => a.value == action);
    }

    static getType(state: EquipmentStateName): string {
        switch (state) {
            case EquipmentStateName.EQUIPMENT_AVAILABLE:
                return 'bg-status-success';
            case EquipmentStateName.EQUIPMENT_BROKEN:
            case EquipmentStateName.EQUIPMENT_CONTAMINATED:
            case EquipmentStateName.EQUIPMENT_UNAVAILABLE:
            case EquipmentStateName.EQUIPMENT_LOST:
                return 'bg-status-danger';
            case EquipmentStateName.EQUIPMENT_MAINTENANCE:
            case EquipmentStateName.EQUIPMENT_CHARGING:
            case EquipmentStateName.EQUIPMENT_REVIEW_REQUIRED:
            case EquipmentStateName.EQUIPMENT_IN_REVIEW:
            case EquipmentStateName.EQUIPMENT_MAINTENANCE_REQUIRED:
            case EquipmentStateName.EQUIPMENT_INCOMPLETE:
            case EquipmentStateName.EQUIPMENT_WAITING_FOR_RETURN:
                return 'bg-status-warning';
            case EquipmentStateName.EQUIPMENT_IN_USE:
                return 'bg-brand-secondary';
            case EquipmentStateName.EQUIPMENT_CREATED:
            case EquipmentStateName.EQUIPMENT_CERTIFICATION:
            case EquipmentStateName.EQUIPMENT_MAINTAINED:
            case EquipmentStateName.EQUIPMENT_REVIEWED:
                return 'bg-status-info';
        }

        return 'bg-status-danger';
    }

    static getBadgeVariant(state: EquipmentStateName): EntityStatusBadgeVariant {
        switch (state) {
            case EquipmentStateName.EQUIPMENT_CREATED:
                return EntityStatusBadgeVariant.Draft;
            case EquipmentStateName.EQUIPMENT_AVAILABLE:
            case EquipmentStateName.EQUIPMENT_MAINTAINED:
            case EquipmentStateName.EQUIPMENT_REVIEWED:
            case EquipmentStateName.EQUIPMENT_FOUND:
                return EntityStatusBadgeVariant.Completed;
            case EquipmentStateName.EQUIPMENT_IN_USE:
            case EquipmentStateName.EQUIPMENT_IN_TRANSIT:
            case EquipmentStateName.EQUIPMENT_CHARGING:
            case EquipmentStateName.EQUIPMENT_CERTIFICATION:
                return EntityStatusBadgeVariant.AwaitingPickUp;
            case EquipmentStateName.EQUIPMENT_MAINTENANCE_REQUIRED:
            case EquipmentStateName.EQUIPMENT_INCOMPLETE:
            case EquipmentStateName.EQUIPMENT_MAINTENANCE:
            case EquipmentStateName.EQUIPMENT_IN_MAINTENANCE:
            case EquipmentStateName.EQUIPMENT_REVIEW_REQUIRED:
            case EquipmentStateName.EQUIPMENT_IN_REVIEW:
            case EquipmentStateName.EQUIPMENT_WAITING_FOR_RETURN:
                return EntityStatusBadgeVariant.AwaitingDropOff;
            case EquipmentStateName.EQUIPMENT_UNAVAILABLE:
            case EquipmentStateName.EQUIPMENT_LOST:
            case EquipmentStateName.EQUIPMENT_BROKEN:
            case EquipmentStateName.EQUIPMENT_CONTAMINATED:
                return EntityStatusBadgeVariant.Failed;
            case EquipmentStateName.EQUIPMENT_ANY_STATE:
            case EquipmentStateName.UNKNOWN:
            default:
                return EntityStatusBadgeVariant.Cancelled;
        }
    }
}
